module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAAzM1OzxJSpydnp+gocPE5Obn8vOai+2RAAAAmElEQVQoz3XT2RKFIAgAUKxsNe814/9/NRobFwQePcMyqAB1jCNoYQ7Ewyh24h3xNJpZKytZtACifiZqNkEr67QxptnmEGamJS8ghja3qkl4tZW30m+5/kvpuwEMGCdpYaTDi1bEmxBWUcnWdyAnKJlL4zq6jnTmPbNa/Y9bk9sZU2aNdlapYFlF+1SxpJqR7oi7Ud88+w4PBqYMd9j8tvsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/image/zhuangshi2.png
// module id = kjl/
// module chunks = 1